<script>
  import Logo from "./assets/Logo.svelte";
  import Web from "./assets/Web.svelte";
  import Mobile from "./assets/Mobile.svelte";
  import Desktop from "./assets/Desktop.svelte";
  import QuoteLeft from "./assets/QuoteLeft.svelte";
  import QuoteRight from "./assets/QuoteRight.svelte";
  import Facebook from "./assets/Facebook.svelte";
  import LinkedIn from "./assets/LinkedIn.svelte";
  import Address from "./assets/Address.svelte";
  import Email from "./assets/Email.svelte";
  import Phone from "./assets/Phone.svelte";
  import { onMount } from "svelte";
  onMount(() => {
    jarallax(document.querySelectorAll(".jarallax"));
  });
  let y, h1, h2, h3, h4, h5, h6;
</script>

<svelte:window bind:scrollY={y} />
<header class="header" class:raise={y > 0}>
  <div class="flex font-medium h-16 items-center max-w-6xl mx-auto px-4">
    <a class="mx-4" href="#mission">
      <Logo class="h-5 text-primary" />
    </a>
    <div class="flex-1" />
    <a class="link" href="#mission" class:current={y < h1}>Mission</a>
    <a
      class="link"
      href="#service"
      class:current={y >= h1 && y < h1 + h2}
      class:next={y < h1}>
      Service
    </a>
    <a
      class="link"
      href="#about"
      class:current={y >= h1 + h2 && y < h1 + h2 + h3}
      class:next={y >= h1 && y < h1 + h2}>
      About
    </a>
    <a
      class="link"
      href="#process"
      class:current={y >= h1 + h2 + h3 && y < h1 + h2 + h3 + h4}
      class:next={y >= h1 + h2 && y < h1 + h2 + h3}>
      Process
    </a>
    <a
      class="link"
      href="#career"
      class:current={y >= h1 + h2 + h3 + h4 && y < h1 + h2 + h3 + h4 + h5}
      class:next={y >= h1 + h2 + h3 && y < h1 + h2 + h3 + h4}>
      Career
    </a>
    <a
      class="link"
      href="#clients"
      class:current={y >= h1 + h2 + h3 + h4 + h5}
      class:next={y >= h1 + h2 + h3 + h4 && y < h1 + h2 + h3 + h4 + h5}>
      Clients
    </a>
    <a class="link" href="#mission" class:next={y >= h1 + h2 + h3 + h4 + h5}>
      Mission
    </a>
  </div>
</header>
<section class="jarallax" id="mission" bind:offsetHeight={h1}>
  <div
    class="flex flex-col font-medium justify-center max-w-6xl min-h-screen
    mx-auto pb-16 pt-32 px-8">
    <h1 class="leading-tight text-4xl uppercase md:text-5xl">
      Our values are
      <br />
      <span class="text-primary">fast, simple &</span>
      <br />
      <span class="text-primary">affordable</span>
    </h1>
    <p class="leading-loose pt-4 text-xl">
      Consult us for hassle-free software development
    </p>
  </div>
  <img alt="mission" class="jarallax-img opacity-50" src="/mission.jpg" />
</section>
<section
  class="max-w-6xl mx-auto px-8 py-16 text-center text-primary"
  id="service"
  bind:offsetHeight={h2}>
  <h2 class="font-medium leading-tight text-4xl">Our Service</h2>
  <hr class="bg-primary border-0 h-1 mb-16 mt-2 mx-auto w-16" />
  <div class="-m-4 flex flex-col sm:flex-row">
    <div class="flex-1 p-4">
      <div class="px-4 py-8 shadow-z1">
        <Web class="h-20 mb-4 mx-auto" />
        <h3 class="font-medium leading-tight text-lg uppercase">
          Web
          <br />
          Applications
        </h3>
        <p class="leading-loose pt-4 text-secondary text-sm">
          We can develop responsive web applications that adapt to all screen
          sizes using frontend frameworks such as Vue or React.
        </p>
      </div>
    </div>
    <div class="flex-1 p-4">
      <div class="px-4 py-8 shadow-z1">
        <Mobile class="h-20 mb-4 mx-auto" />
        <h3 class="font-medium leading-tight text-lg uppercase">
          Mobile
          <br />
          Applications
        </h3>
        <p class="leading-loose pt-4 text-secondary text-sm">
          We can provide you with performant mobile applications for Android and
          iOS through the use of Facebook's React Native framework.
        </p>
      </div>
    </div>
    <div class="flex-1 p-4">
      <div class="px-4 py-8 shadow-z1">
        <Desktop class="h-20 mb-4 mx-auto" />
        <h3 class="font-medium leading-tight text-lg uppercase">
          Desktop
          <br />
          Applications
        </h3>
        <p class="leading-loose pt-4 text-secondary text-sm">
          Our service includes making modern desktop applications with highly
          customized user interfaces through the use of Vue and Electron.
        </p>
      </div>
    </div>
  </div>
</section>
<section class="flex" id="about" bind:offsetHeight={h3}>
  <div class="flex-1 hidden jarallax sm:block">
    <img alt="about" class="jarallax-img" src="/about.jpg" />
  </div>
  <div class="bg-secondary flex-1 text-white">
    <div class="px-8 py-16">
      <h2 class="font-medium leading-tight text-4xl">About Us</h2>
      <p class="leading-loose pt-4">
        The next technological revolution is here and ready to transform lives
        once again. At Decenbase, our goals are to help you digitize your
        business and streamline its internal processes. We aim to greatly
        increase your business efficiency and to significantly reduce your
        long-term costs.
      </p>
      <p class="leading-loose pt-4">
        We can provide you with customized web, mobile, or desktop applications
        to meet any business requirements. We are determined to develop
        high-quality software which matches or exceeds industry standards in
        terms of speed, security, and scalability.
      </p>
    </div>
  </div>
</section>
<section
  class="max-w-6xl mx-auto px-8 py-16 text-center text-primary"
  id="process"
  bind:offsetHeight={h4}>
  <h2 class="font-medium leading-tight text-4xl">Work Process</h2>
  <hr class="bg-primary border-0 h-1 mb-16 mt-2 mx-auto w-16" />
  <div class="-m-4 flex flex-wrap">
    <div class="my-4 px-4 w-full sm:w-1/2 md:w-1/4">
      <img alt="Step 1" class="mb-4 mx-auto w-40" src="/step-1.png" />
      <h3 class="font-medium leading-tight text-lg uppercase">Design</h3>
      <p class="leading-loose pt-4 text-secondary text-sm">
        Business analysis
        <br />
        Define requirements
        <br />
        Architecture design
        <br />
      </p>
    </div>
    <div class="my-4 px-4 w-full sm:w-1/2 md:w-1/4">
      <img alt="Step 2" class="mb-4 mx-auto w-40" src="/step-2.png" />
      <h3 class="font-medium leading-tight text-lg uppercase">Develop</h3>
      <p class="leading-loose pt-4 text-secondary text-sm">
        Iterative development
        <br />
        Milestones review
        <br />
        Evaluate feedback
        <br />
      </p>
    </div>
    <div class="my-4 px-4 w-full sm:w-1/2 md:w-1/4">
      <img alt="Step 3" class="mb-4 mx-auto w-40" src="/step-3.png" />
      <h3 class="font-medium leading-tight text-lg uppercase">Deliver</h3>
      <p class="leading-loose pt-4 text-secondary text-sm">
        Handover code
        <br />
        Server deployment
        <br />
        Software demonstration
        <br />
      </p>
    </div>
    <div class="my-4 px-4 w-full sm:w-1/2 md:w-1/4">
      <img alt="Step 4" class="mb-4 mx-auto w-40" src="/step-4.png" />
      <h3 class="font-medium leading-tight text-lg uppercase">Maintain</h3>
      <p class="leading-loose pt-4 text-secondary text-sm">
        Bug fixes
        <br />
        Security updates
        <br />
        QoL improvements
        <br />
      </p>
    </div>
  </div>
</section>
<section class="flex" id="career" bind:offsetHeight={h5}>
  <div class="flex-1 hidden jarallax sm:block">
    <img alt="career" class="jarallax-img" src="/career.jpg" />
  </div>
  <div class="bg-secondary flex-1 text-white">
    <div class="px-8 py-16">
      <h2 class="font-medium leading-tight text-4xl">Work with Us</h2>
      <p class="leading-loose pt-4">
        At Decenbase, we are a group of young and ambitious individuals working
        towards a common goal. Our company is a result-oriented work environment
        with flexible working arrangements.
      </p>
      <p class="leading-loose pt-4">
        We are growing quickly and actively seeking talented individuals to join
        our team. If you feel that you would be a good fit for Decenbase, please
        contact us to become a part of our family.
      </p>
    </div>
  </div>
</section>
<section
  class="max-w-6xl mx-auto px-8 py-16 text-center text-primary"
  id="clients"
  bind:offsetHeight={h6}>
  <h2 class="font-medium leading-tight text-4xl">Our Clients</h2>
  <hr class="bg-primary border-0 h-1 mb-16 mt-2 mx-auto w-16" />
  <div class="-m-4 flex flex-col sm:flex-row">
    <div class="flex-1 mt-16 p-4">
      <div class="px-4 py-8 relative shadow-z1">
        <img
          alt="person 1"
          class="-m-24 mb-4 mx-auto rounded-full w-32"
          src="/person-1.jpg" />
        <h3 class="font-medium leading-tight text-lg">
          Somphong Siraprapaphong
        </h3>
        <h4 class="font-medium leading-loose pt-4 text-xs">
          Managing Director
          <br />
          Ocean Feed
        </h4>
        <p class="font-prompt leading-loose pt-4 text-secondary">
          การจัดการสินค้าเข้าออกเป็นระบบระเบียบมากขึ้นเยอะเลย
        </p>
        <QuoteLeft class="absolute h-8 left-0 m-4 top-0" />
        <QuoteRight class="absolute h-8 m-4 right-0 top-0" />
      </div>
      <hr class="bg-primary border-0 h-2 mx-4 -z-10" />
    </div>
    <div class="flex-1 mt-16 p-4">
      <div class="px-4 py-8 relative shadow-z1">
        <img
          alt="person 2"
          class="-m-24 mb-4 mx-auto rounded-full w-32"
          src="/person-2.jpg" />
        <h3 class="font-medium leading-tight text-lg">Apimuk Wittayanakorn</h3>
        <h4 class="font-medium leading-loose pt-4 text-xs">
          Managing Director
          <br />
          CNS Container and Warehouse Logistics Service
        </h4>
        <p class="font-prompt leading-loose pt-4 text-secondary">
          ดีเซนเบสให้คำปรึกษาที่ดีในเรื่องของ Mobile App และ IoT สำหรับ Startup
          ของผม
        </p>
        <QuoteLeft class="absolute h-8 left-0 m-4 top-0" />
        <QuoteRight class="absolute h-8 m-4 right-0 top-0" />
      </div>
      <hr class="bg-primary border-0 h-2 mx-4 -z-10" />
    </div>
    <div class="flex-1 mt-16 p-4">
      <div class="px-4 py-8 relative shadow-z1">
        <img
          alt="person 3"
          class="-m-24 mb-4 mx-auto rounded-full w-32"
          src="/person-3.jpg" />
        <h3 class="font-medium leading-tight text-lg">Chatchawan Boonkaew</h3>
        <h4 class="font-medium leading-loose pt-4 text-xs">
          Managing Director
          <br />
          CBS Processor and Communication
        </h4>
        <p class="font-prompt leading-loose pt-4 text-secondary">
          เวลามีงานอะไรกะทันหัน ดีเซนเบสจะหาทางช่วยได้เสมอ
        </p>
        <QuoteLeft class="absolute h-8 left-0 m-4 top-0" />
        <QuoteRight class="absolute h-8 m-4 right-0 top-0" />
      </div>
      <hr class="bg-primary border-0 h-2 mx-4 -z-10" />
    </div>
  </div>
</section>
<footer class="bg-secondary text-sm text-white">
  <div class="flex flex-col-reverse max-w-6xl mx-auto p-4 sm:flex-row">
    <div class="flex-1 p-4">
      <Logo class="h-5" />
      <p class="leading-loose pt-4">
        Consult us for hassle-free software development
      </p>
      <div class="flex items-center pt-4">
        <Facebook class="mr-4 w-4" />
        <a
          class="flex-1 underline"
          href="https://www.facebook.com/Decenbase"
          target="_blank">
          Facebook
        </a>
        <LinkedIn class="mr-4 w-4" />
        <a
          class="flex-1 underline"
          href="https://www.linkedin.com/company/decenbase"
          target="_blank">
          LinkedIn
        </a>
      </div>
      <p class="leading-loose pt-4">© Copyright 2019 Decenbase</p>
    </div>
    <div class="flex-1 p-4">
      <h3 class="font-medium leading-tight text-lg">Contact Us</h3>
      <div class="flex items-center pt-4">
        <Address class="mr-4 w-4" />
        <a
          class="flex-1 underline"
          href="https://goo.gl/maps/sHauwMK8AUhY76Q28"
          target="_blank">
          615/53 Rama II Road, Samae Dam, Bang Khun Thian, Bangkok, Thailand
          10150
        </a>
      </div>
      <div class="flex items-center pt-4">
        <Email class="mr-4 w-4" />
        <a class="flex-1 underline" href="mailto:info@decenbase.com">
          info@decenbase.com
        </a>
      </div>
      <div class="flex items-center pt-4">
        <Phone class="mr-4 w-4" />
        <a class="flex-1 underline" href="tel:+6689-789-6272">
          (+66)89-789-6272
        </a>
      </div>
    </div>
  </div>
</footer>
